function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["name", "error", "allowKeyCreation", "light", "readonly", "noIntegrationsModal"],
  _excluded2 = ["errorDialog"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { InlineLoading, CopyButton } from "@carbon/react";
import SecretPickerDialog from "../dialogs/SecretPickerDialog";
import SecretMintingDialog from "../dialogs/SecretMintingDialog";
import ErrorDialog from "../dialogs/ErrorDialog";
import { xhrPromise } from "../../utils/xhr";
import { initLocales } from "../../utils/locales";
import { ErrorMessage } from "../../utils/react-util";
import InputBoxIcon from "../common/InputBoxIcon";
import vaultUtil from "../../utils/vault-util";
import SecretReference from "../common/SecretReference";
import { idContext, i18nContext } from "../PropertyTable/table-context";
var SecretInput = /*#__PURE__*/function (_Component) {
  function SecretInput(props) {
    var _this;
    _classCallCheck(this, SecretInput);
    _this = _callSuper(this, SecretInput, [props]);
    _this.i18n = initLocales(_this.props.lang, _this.props.i18nStrings);
    var isRef = _this.props.vaultEnabled && !!vaultUtil.parseValue(_this.props.value);
    _this.state = {
      allowReveal: !_this.props.value,
      allowCopy: !_this.props.value || isRef,
      revealed: false,
      isReference: isRef,
      value: props.value || "",
      rawValue: props.value || "",
      unwrapping: false,
      error: "",
      modalOpen: false,
      errorDialog: {
        isOpen: false,
        title: "",
        description: ""
      }
    };
    _this.inputField = /*#__PURE__*/React.createRef();
    _this.createAPIKeyUI = /*#__PURE__*/React.createRef();
    autoBind(_this);
    return _this;
  }
  _inherits(SecretInput, _Component);
  return _createClass(SecretInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Treat null, undefined and "" as the same value
      if ((this.props.value || "") !== (prevProps.value || "")) {
        if ((this.state.value || "") !== (this.props.value || "")) {
          // Value has been changed by parent control, get back
          // to the original state
          var isRef = this.props.vaultEnabled && !!vaultUtil.parseValue(this.props.value);
          var extraState = {
            allowReveal: !this.props.value,
            allowCopy: !this.props.value || isRef,
            revealed: false,
            isReference: isRef
          };
          this.setValue(this.props.value, extraState);
        }
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(evt) {
      var _this$state = this.state,
        allowReveal = _this$state.allowReveal,
        allowCopy = _this$state.allowCopy;
      if (evt.target.value !== undefined && evt.target.value.length === 0) {
        // All content has been erased, allow reveal again
        allowReveal = true;
        allowCopy = true;
      }
      // If user types or pastes a reference we're not showing the tag control
      this.setValue(evt.target.value, {
        allowReveal: allowReveal,
        allowCopy: allowCopy
      });
    }
  }, {
    key: "onEyeClick",
    value: function onEyeClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.setState(function (prevState) {
        return {
          revealed: !prevState.revealed
        };
      });
    }
  }, {
    key: "onClearSecretRef",
    value: function onClearSecretRef(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var extraState = {
        allowReveal: true,
        allowCopy: true,
        revealed: false,
        isReference: false
      };
      this.setValue("", extraState);
    }
  }, {
    key: "onOpenSecretPicker",
    value: function onOpenSecretPicker(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.setState({
        modalOpen: true
      });
      this.props.onModalEvent && this.props.onModalEvent(true);
    }
  }, {
    key: "onSecretPickerClose",
    value: function onSecretPickerClose() {
      this.setState({
        modalOpen: false
      });
      this.props.onModalEvent && this.props.onModalEvent(false);
      var createButtonElement = this.createAPIKeyUI.current && this.createAPIKeyUI.current.createButton;
      if (createButtonElement && createButtonElement.current) {
        createButtonElement.current.focus();
      }
    }
  }, {
    key: "onCloseErrorDialog",
    value: function onCloseErrorDialog() {
      this.setState({
        errorDialog: {
          isOpen: false,
          title: "",
          description: ""
        }
      });
    }
  }, {
    key: "onSecretChosen",
    value: function onSecretChosen(secretParams) {
      this.onSecretPickerClose();
      this.setState({
        unwrapping: true,
        value: "",
        error: "",
        revealed: false,
        isReference: false
      });
      this.setValue(secretParams.reference, {
        allowReveal: false,
        allowCopy: true,
        revealed: false,
        isReference: true
      });
    }
  }, {
    key: "onCreateAPIKey",
    value: function onCreateAPIKey(evt, currentLimit, saveAPIKeyOptions) {
      var _this2 = this;
      var limit = currentLimit;
      this.setState({
        unwrapping: true,
        value: "",
        error: "",
        isReference: false
      });
      var createPromise;
      var createAPIKeyUrl;
      var createGPGKeyUrl;
      switch (this.props.keyCreationType) {
        case "service-id":
          createAPIKeyUrl = "/devops/setup/api/v2/serviceIds?&env_id=".concat(this.props.envId);
          createPromise = xhrPromise(createAPIKeyUrl, {
            dataType: "json",
            method: "POST",
            body: {
              name: saveAPIKeyOptions.name,
              description: saveAPIKeyOptions.description,
              account_id: this.props.bssAccount
            },
            bssAccount: this.props.bssAccount,
            accountContext: this.props.accountContext
          });
          break;
        case "gpg-key":
          createGPGKeyUrl = "/devops/setup/api/v2/gpgKeys?account_context=".concat(this.props.accountContext) + "&bss_account=".concat(this.props.bssAccount, "&env_id=").concat(this.props.envId);
          createPromise = xhrPromise(createGPGKeyUrl, {
            dataType: "json",
            method: "POST",
            body: {
              name: saveAPIKeyOptions.name,
              email: saveAPIKeyOptions.description
            },
            bssAccount: this.props.bssAccount,
            accountContext: this.props.accountContext
          });
          break;
        case "api-key":
        default:
          createAPIKeyUrl = "/devops/setup/api/v2/apiKeys?account_context=".concat(this.props.accountContext) + "&bss_account=".concat(this.props.bssAccount, "&env_id=").concat(this.props.envId);
          createPromise = xhrPromise(createAPIKeyUrl, {
            dataType: "json",
            method: "POST",
            body: {
              name: saveAPIKeyOptions.name,
              description: saveAPIKeyOptions.description,
              boundTo: "self"
            },
            bssAccount: this.props.bssAccount,
            accountContext: this.props.accountContext
          });
          break;
      }
      return createPromise.then(function (result) {
        // Get the api-key from the result
        var generatedKey;
        switch (_this2.props.keyCreationType) {
          case "service-id":
            generatedKey = result.body && result.body.apikey;
            break;
          case "gpg-key":
            generatedKey = result.body.gpgKey;
            break;
          case "api-key":
          default:
            generatedKey = result.body && result.body.entity && result.body.entity.apiKey;
            break;
        }

        // check if lead character of the generated api key contains a  '-'
        if (["api-key", "service-id"].includes(_this2.props.keyCreationType) && generatedKey && generatedKey.indexOf("-") === 0) {
          // initilise limit to 10 tries otherwise decrease count
          limit = limit === undefined ? 10 : limit - 1;
          if (limit > 0) {
            _this2.onCreateAPIKey(evt, limit, saveAPIKeyOptions);
          } else {
            // create custom error object, in format expected by existing catch
            throw {
              body: {
                state: _this2.i18n.messages.systemError
              }
            };
          }
        } else {
          if (_this2.props.vaultEnabled && saveAPIKeyOptions.saveKeyChecked) {
            var _this2$props = _this2.props,
              accountContext = _this2$props.accountContext,
              bssAccount = _this2$props.bssAccount,
              toolchainId = _this2$props.toolchainId;
            if (!saveAPIKeyOptions.toolcard) {
              var saveAPIKeyUrl = "".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(saveAPIKeyOptions.provider);
              if (!saveAPIKeyOptions.createNewInstance) {
                saveAPIKeyUrl += "/".concat(saveAPIKeyOptions.instance);
                if (saveAPIKeyOptions.provider === vaultUtil.SM_PROVIDER_TYPE) {
                  saveAPIKeyUrl += "/groups/".concat(saveAPIKeyOptions.group);
                }
              }
              saveAPIKeyUrl += "?region=".concat(saveAPIKeyOptions.region);
              saveAPIKeyUrl += "&resource_group_id=".concat(saveAPIKeyOptions.resource_group);
              var keyData = {
                key: {
                  name: saveAPIKeyOptions.secret,
                  value: generatedKey
                }
              };
              var _requestData = keyData;
              if (saveAPIKeyOptions.createNewInstance) {
                var instanceData = {
                  instance: {
                    name: saveAPIKeyOptions.instance
                  }
                };
                _requestData = _objectSpread(_objectSpread(_objectSpread({}, instanceData), keyData), {}, {
                  accountType: _this2.props.accountType
                });
              }

              // This request does not need a toolchainId or vaultIntegrations
              return xhrPromise(saveAPIKeyUrl, {
                dataType: "json",
                method: "POST",
                env_id: _this2.props.envId,
                accountContext: accountContext,
                bssAccount: bssAccount,
                body: _requestData
              }).then(function (result) {
                _this2.setValue(result.body, {
                  allowReveal: false,
                  allowCopy: true,
                  revealed: false,
                  isReference: true
                }, generatedKey);
              })["catch"](function (err) {
                var _err$body;
                _this2.setValue(generatedKey, {
                  allowReveal: true,
                  allowCopy: true,
                  revealed: false,
                  isReference: false
                });
                var errorMsg = (_err$body = err.body) !== null && _err$body !== void 0 && _err$body.state && typeof err.body.state === "string" ? err.body.state : _this2.i18n.messages.genericErrorMsg;
                _this2.setState({
                  errorDialog: {
                    isOpen: true,
                    title: _this2.i18n.messages.errorSavingAPIKey,
                    description: errorMsg
                  }
                });
              });
            } // Toolcard
            var saveTemplate = "".concat(vaultUtil.SECRETS_API_PATH, "?reference=").concat(saveAPIKeyOptions.reference);
            var requestData = {};
            if (saveAPIKeyOptions.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_PROVIDER_TYPE))) {
              // Note, minter secret value is json instead of string
              requestData["secret-value"] = _defineProperty({}, saveAPIKeyOptions.secret, generatedKey);
            } else {
              requestData["secret-value"] = generatedKey;
            }
            if (!toolchainId) {
              // Setup phase add vaultIntegrations
              requestData["vti-instances"] = _this2.props.vaultIntegrations || [];
            }
            return xhrPromise(saveTemplate, {
              dataType: "json",
              method: "POST",
              env_id: _this2.props.envId,
              accountContext: accountContext,
              bssAccount: bssAccount,
              toolchainId: toolchainId,
              body: requestData
            }).then(function (result) {
              _this2.setValue(result.body, {
                allowReveal: false,
                allowCopy: true,
                revealed: false,
                isReference: true
              }, generatedKey);
            })["catch"](function (err) {
              var _err$body2;
              _this2.setValue(generatedKey, {
                allowReveal: true,
                allowCopy: true,
                revealed: false,
                isReference: false
              });
              var errorMsg = (_err$body2 = err.body) !== null && _err$body2 !== void 0 && _err$body2.state && typeof err.body.state === "string" ? err.body.state : _this2.i18n.messages.genericErrorMsg;
              _this2.setState({
                errorDialog: {
                  isOpen: true,
                  title: _this2.i18n.messages.errorSavingAPIKey,
                  description: errorMsg
                }
              });
            });
          }
          _this2.setValue(generatedKey, {
            allowReveal: true,
            allowCopy: true,
            revealed: false,
            isReference: false
          });
        }
      })["catch"](function (err) {
        console.log(err);
        _this2.setValue("", {
          allowReveal: true,
          allowCopy: true,
          isReference: false
        });
        var errorMsg = _this2.i18n.messages.genericErrorMsg;
        var htmlErrorMsg;
        if (err.body && err.body.state) {
          errorMsg = err.body.state;
        } else if (err.xhr) {
          // account for non-secrets api error conditions such as iam api key creation api failures...
          var _errorMsg = err.body && err.body.description ? err.body.description : undefined;
          if (!_errorMsg && err.xhr.status === 422) {
            // if no error message supplied and it's a 422, then it's
            // quite possibly down to hitting the apikey limit...
            htmlErrorMsg = _this2.i18n.messages.possibleApikeyLimitErrorMsg;
          } else {
            // otherwise, use any supplied error description message as-is...
            // stray case of error being undefined and not a 422 falls
            // into the default genericErrorMsg message being applied
            errorMsg = _errorMsg || errorMsg;
          }
        } else if (err && err.message) {
          errorMsg = err.message;
        }
        _this2.setState({
          errorDialog: {
            isOpen: true,
            title: _this2.i18n.messages.errorCreatingAPIKey,
            description: errorMsg,
            dangerousHtmlDescription: htmlErrorMsg
          }
        });
      });
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this3 = this;
      var extraState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rawValue = arguments.length > 2 ? arguments[2] : undefined;
      // Utility function used further down in this function
      var updateState = function updateState(secretValue) {
        // Don't allow setting of null or undefined
        secretValue = secretValue || "";
        var isCrnReference = _this3.props.vaultEnabled && vaultUtil.isCrnReference(secretValue);
        _this3.setState(_objectSpread(_objectSpread({}, extraState), {}, {
          value: secretValue,
          unwrapping: false,
          error: "",
          rawValue: rawValue || value
        }, isCrnReference ? {
          isReference: true,
          allowReveal: false,
          allowCopy: true
        } : {}), function () {
          if (_this3.props.onChange) {
            _this3.props.onChange({
              target: _this3.inputField.current
            });
          }
        });
      };
      if (this.props.beforeOnChange && typeof this.props.beforeOnChange === "function") {
        // Invoke preprocessing, must wait on callback to proceed
        // Allows augmentation of the value (longform ref -> vti)
        this.props.beforeOnChange(value || "", function (newValue) {
          updateState(newValue);
        });
      } else {
        // No preprocessing
        updateState(value);
      }
    }
  }, {
    key: "copyCommand",
    value: function copyCommand(elemId) {
      var copyText = document.getElementById(elemId);
      // Note, the copy command only works when the textarea is
      // programmatically visible in the DOM. The textare has both:
      // class=bx-visually-hidden and style=visibility:hidden
      // Temporarily changing visibility to visible so the copy command
      // can programmatically see the textarea. But the bx-visually-hidden
      // class will ensure that the users don't visually see the textarea
      // because it is of 1x1px size and clip'd to 0x0px.
      // We don't leave it as visibility: visible, because then
      // the accessibility screen readers would consider it as visible and
      // read out it's name - but really they shouldn't interact with it.
      copyText.style.visibility = "visible";
      copyText.select();
      document.execCommand("copy");
      copyText.style.visibility = "hidden";
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        error = _this$props.error,
        allowKeyCreation = _this$props.allowKeyCreation,
        light = _this$props.light,
        readonly = _this$props.readonly,
        noIntegrationsModal = _this$props.noIntegrationsModal,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var _this$state2 = this.state,
        errorDialog = _this$state2.errorDialog,
        state = _objectWithoutProperties(_this$state2, _excluded2);
      var toolTip = this.props.accountType === "STANDARD" ? this.i18n.messages.billableAccountRequired : this.i18n.messages.titleSecretPicker;
      var pickerIdPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-retrieve") : "retrieve";
      var createIdPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-save") : "save";
      var keyIconAnalyticsLabel = this.props.analyticsPrefix ? "".concat(this.props.analyticsPrefix, "-secret-picker-key-btn") : null;
      var label = this.props.label || this.props.name;
      var inputClassName = "cds--text-input";
      inputClassName += light ? " cds--text-input--light" : "";
      inputClassName += this.props.inputClassModifier ? " ".concat(this.props.inputClassModifier) : "";
      var optionals = this.props.minHeight ? {
        style: {
          minHeight: this.props.minHeight
        }
      } : {};
      // Note, checking unwrapping vs showSpinner in different places
      var showSpinner = state.unwrapping || this.props.spinner === "start";
      return /*#__PURE__*/React.createElement(i18nContext.Provider, {
        value: this.i18n
      }, /*#__PURE__*/React.createElement(idContext.Provider, {
        value: {
          accountContext: this.props.accountContext,
          bssAccount: this.props.bssAccount,
          envId: this.props.envId,
          toolchainId: this.props.toolchainId
        }
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: "ocr--root-container"
      }, optionals), /*#__PURE__*/React.createElement("div", {
        className: allowKeyCreation ? "ocr--split-row-container" : "ocr--row-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-with-icons-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-container"
      }, /*#__PURE__*/React.createElement("input", _extends({
        name: name,
        id: name,
        "data-invalid": !state.unwrapping && (state.error || error) ? true : null,
        autoComplete: "new-password",
        onChange: this.onInputChange,
        type: this.state.revealed ? "input" : "password",
        placeholder: label,
        ref: this.inputField,
        className: inputClassName + (state.isReference ? " ocr--hide-text" : ""),
        value: state.value,
        disabled: state.unwrapping || readonly,
        "aria-label": label,
        readOnly: state.isReference || readonly ? true : null,
        "aria-hidden": state.isReference ? true : null,
        tabIndex: state.isReference ? -1 : 0
      }, this.props.inputPropModifier || {})), state.isReference ? /*#__PURE__*/React.createElement(SecretReference, {
        reference: state.value
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "ocr--spinner-container".concat(showSpinner ? "" : " ocr--hidden")
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })), /*#__PURE__*/React.createElement("textarea", {
        className: "cds--visually-hidden",
        readOnly: true,
        "aria-hidden": "true",
        id: "".concat(name, "-hidden"),
        value: state.rawValue,
        tabIndex: "-1",
        "aria-label": label,
        style: {
          visibility: "hidden"
        }
      })), state.allowReveal && state.value && !readonly ? /*#__PURE__*/React.createElement(InputBoxIcon, {
        className: "ocr--eye-button",
        onClick: this.onEyeClick,
        title: state.revealed ? this.i18n.messages.hidePassword : this.i18n.messages.showPassword,
        disabled: showSpinner,
        iconName: state.revealed ? "viewoff" : "view"
      }) : null, state.allowCopy && state.value && !readonly ? /*#__PURE__*/React.createElement(CopyButton, {
        className: "ocr--copy-button ocr--icon-button",
        disabled: showSpinner,
        onClick: this.copyCommand.bind(this, "".concat(name, "-hidden")),
        feedback: this.i18n.messages.copied,
        title: this.i18n.messages.copyToClipboard
      }) : null, this.props.vaultEnabled && !readonly ? /*#__PURE__*/React.createElement(React.Fragment, null, state.isReference ? /*#__PURE__*/React.createElement(InputBoxIcon, {
        className: "ocr--picker-button",
        onClick: this.onClearSecretRef,
        title: this.i18n.messages.clearSecretReference,
        disabled: this.props.accountType === "STANDARD" || showSpinner,
        iconName: "close"
      }) : null, /*#__PURE__*/React.createElement(InputBoxIcon, {
        analyticsLabel: keyIconAnalyticsLabel,
        className: "ocr--picker-button",
        onClick: this.onOpenSecretPicker,
        title: toolTip,
        disabled: this.props.accountType === "STANDARD" || showSpinner,
        iconName: "key"
      }), /*#__PURE__*/React.createElement(SecretPickerDialog, _extends({}, rest, {
        noIntegrationsModal: noIntegrationsModal,
        modalOpen: this.state.modalOpen,
        onClose: this.onSecretPickerClose,
        onSecretChosen: this.onSecretChosen,
        idPrefix: pickerIdPrefix,
        mock: this.props.mock,
        i18n: this.i18n
      }))) : null), allowKeyCreation && !readonly ? /*#__PURE__*/React.createElement(SecretMintingDialog, _extends({}, rest, {
        onCreateAPIKey: this.onCreateAPIKey,
        ref: this.createAPIKeyUI,
        idPrefix: createIdPrefix,
        i18n: this.i18n,
        mock: this.props.mock,
        secretInputName: name
      })) : null), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: !state.unwrapping && (state.error || error)
      }), /*#__PURE__*/React.createElement(ErrorDialog, {
        modalOpen: errorDialog.isOpen,
        title: errorDialog.title,
        description: errorDialog.description,
        dangerousHtmlDescription: errorDialog.dangerousHtmlDescription,
        onClose: this.onCloseErrorDialog
      }))));
    }
  }]);
}(Component);
SecretInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  allowKeyCreation: PropTypes.bool,
  keyCreationType: PropTypes.string,
  onModalEvent: PropTypes.func,
  onChange: PropTypes.func,
  accountContext: PropTypes.string.isRequired,
  bssAccount: PropTypes.string.isRequired,
  i18nStrings: PropTypes.object,
  envId: PropTypes.string,
  vaultIntegrations: PropTypes.array,
  toolchainName: PropTypes.string,
  vaultEnabled: PropTypes.bool,
  idPrefix: PropTypes.string,
  accountType: PropTypes.string,
  beforeOnChange: PropTypes.func,
  inputClassModifier: PropTypes.string,
  inputPropModifier: PropTypes.object,
  spinner: PropTypes.string,
  minHeight: PropTypes.string,
  toolchainId: PropTypes.string,
  lang: PropTypes.string,
  enableSmProvider: PropTypes.bool,
  onlyVtiProviders: PropTypes.bool,
  mock: PropTypes.bool,
  userInfo: PropTypes.object
};
SecretInput.defaultProps = {
  allowKeyCreation: false,
  keyCreationType: "api-key",
  name: "",
  label: "",
  idPrefix: "",
  vaultEnabled: false,
  accountType: "UNKNOWN",
  mock: false,
  enableSmProvider: false
};
export default SecretInput;